<div class="container-fluid">
  <div class="row form-group">
    <div class="col-md-2">
      <label class="marginTop5" for="reportName">Report</label>
    </div>
    <div class="col-md-10">
      <kendo-dropdownlist
        id="reportName"
        [kendoDropDownFilter]="{
          operator: 'contains'
        }"
        [data]="reportList"
        textField="text"
        valueField="value"
        [valuePrimitive]="true"
        [(ngModel)]="exportReport.id"
        (valueChange)="onReportChange($event)"
        name="reportId"
        required
      ></kendo-dropdownlist>
    </div>
  </div>
  <div *ngIf="requireDate" class="row form-group">
    <div class="col-md-2">
      <label class="marginTop5" for="reportDate">{{
        datePickerOptions.label
      }}</label>
    </div>
    <div class="col-md-4">
      <kendo-datepicker
        id="reportDate"
        name="reportDate"
        class="maxWidth"
        placeholder=""
        [format]="datePickerOptions.format"
        [activeView]="datePickerOptions.activeView"
        [bottomView]="datePickerOptions.bottomView"
        [max]="reportMaxDate"
        [disabledDates]="disabledDates"
        [(ngModel)]="exportReport.date"
      ></kendo-datepicker>
      <div class="chubbDarkGreen" *ngIf="isDDAReport">
        <i
          _ngcontent-vol-c969=""
          aria-hidden="true"
          class="fa fa-info-circle fa-2"
        ></i>
        <small>
          The Extraction includes policies bound from last Tuesday to
          Monday.</small
        >
      </div>
      <div class="text-danger" *ngIf="!isDateValid(exportReport.date)">
        <i
          _ngcontent-vol-c969=""
          aria-hidden="true"
          class="fa fa-exclamation-circle fa-2 chubbRed"
        ></i>
        <small> Invalid date. Please select past date.</small>
      </div>
      <div class="text-danger" *ngIf="!validDateRange()">
        <i
          _ngcontent-vol-c969=""
          aria-hidden="true"
          class="fa fa-exclamation-circle fa-2 chubbRed"
        ></i>
        <small> Report Transaction months cannot exceed 24 months.</small>
      </div>
    </div>
    <div class="col-md-2 textAlignCenter" *ngIf="hasDateRange">
      <label class="marginTop5" for="reportDateTo">to</label>
    </div>
    <div class="col-md-4" *ngIf="hasDateRange">
      <kendo-datepicker
        id="reportDateTo"
        class="maxWidth"
        placeholder=""
        [format]="datePickerOptions.format"
        [activeView]="datePickerOptions.activeView"
        [bottomView]="datePickerOptions.bottomView"
        [max]="reportMaxDate"
        [disabledDates]="disabledDates"
        [(ngModel)]="exportReport.dateTo"
      ></kendo-datepicker>
      <div class="text-danger" *ngIf="!validDateTo()">
        <i
          _ngcontent-vol-c969=""
          aria-hidden="true"
          class="fa fa-exclamation-circle fa-2 chubbRed"
        ></i>
        <small> 'To' date must not be earlier than the 'From' date."</small>
      </div>
      <div class="text-danger" *ngIf="!validPresentDateTo()">
        <i
          _ngcontent-vol-c969=""
          aria-hidden="true"
          class="fa fa-exclamation-circle fa-2 chubbRed"
        ></i>
        <small> Invalid date. Please select past date.</small>
      </div>
    </div>
  </div>
  <div class="form-group row" *ngIf="requireDiscount">
    <div class="col-md-2">
      <label class="marginTop5" for="reportDiscount">Discount</label>
    </div>
    <div class="col-md-10">
      <kendo-multiselect
        id="reportDiscount"
        placeholder="Select discount..."
        [autoClose]="false"
        [kendoDropDownFilter]="{
          operator: 'contains'
        }"
        [data]="discountList"
        textField="key"
        valueField="value"
        [valuePrimitive]="true"
        [(ngModel)]="exportReport.discountIds"
        name="discountIds"
      ></kendo-multiselect>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2">
      <button
        (click)="onExport()"
        class="btn btn-primary ld-ext-left chubbGreen_bg chubbGreen_border_btn ml-1 marginTop50"
        [disabled]="!allowExport()"
      >
        <i class="fa fa-download ng-scope" aria-hidden="true"></i> Download
      </button>
    </div>
  </div>
</div>
